import { useCanCreateManagedConnection } from "../useCanCreateManagedConnection";

export function useShowFirstConnectionEmptyState() {
  return useCanCreateManagedConnection().canCreateManagedConnection;
}
